import { takeLeading, put, call } from 'redux-saga/effects';

import { Creators, Types } from 'src/store/redux/SLA/actions';
import slaAPI from 'src/services/api/SLA';
import toaster from 'src/services/toaster';
import { handleErrorResponse } from 'src/lib/helpers/errors';
import { DBErrorMonitor } from 'src/services/error-monitor';

export function* update({ data }: any) {
  try {
    const response = yield call(slaAPI.update, data);
    yield put(Creators.slaConfigUpdateRequestSuccess(response));
    if (data?.integration_contact) {
      toaster.success('Integtaion Contact was updated successfully');
    } else {
      toaster.success('SLA were updated successfully');
    }
  } catch (e) {
    let error = e.response;
    DBErrorMonitor.captureException(e, { saga: 'update', entity: 'SLA' });
    handleErrorResponse(error);
    yield put(Creators.slaConfigUpdateRequestError(error));
  }
}

export function* watchUpdate() {
  yield takeLeading(Types.SLA_CONFIG_UPDATE_REQUEST, update);
}

export default watchUpdate;
